import { SocialMediaTypes, RECEIVE_SOCIAL_MEDIA, ISocialMediaResponse } from "./types";
import { AppThunkAction } from "..";

export const actionCreators = {
    requestCallback:
        (socialMediaResponse: ISocialMediaResponse): AppThunkAction<SocialMediaTypes> =>
        (dispatch, getState) => {
            console.log("socialMedia actions", socialMediaResponse);
            try {
                dispatch({ type: RECEIVE_SOCIAL_MEDIA, callbackData: socialMediaResponse });
                console.log("Action to store social media data complete", getState().monitorData);
            } catch (error) {
                console.log("social media action error", error);
            }
        },
};
